export const DEBOUNCE_MS = 500;
export const KEY_ENTER = 13;
